import ProcessEmail from './ProcessEmail';

export default ProcessEmail;
